import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsCo from '@angular/common/locales/es-CO';

// IMPORTANTE: Registrar ANTES de bootstrap
registerLocaleData(localeEs);
registerLocaleData(localeEsCo, 'es-CO');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
